// extracted by mini-css-extract-plugin
export var closeButton = "_as-2";
export var closeButtonIcon = "_as-3";
export var lightboxContent = "_as-1";
export var lightboxOverlay = "_as-0";